const AVATAR_GRADIENTS = [
  'from-rose-400 to-orange-300',
  'from-violet-400 to-purple-300',
  'from-blue-400 to-cyan-300',
  'from-emerald-400 to-teal-300',
  'from-amber-400 to-yellow-300',
  'from-pink-400 to-fuchsia-300',
  'from-indigo-400 to-blue-300',
  'from-teal-400 to-green-300',
  'from-orange-400 to-red-300',
  'from-cyan-400 to-sky-300',
];

export function nameToGradient(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length];
}
